import React from "react";
import { NavLink } from "react-router-dom";
import data from "../../../data/data.json";
import { Nav } from "react-bootstrap";

const links = data.homeInterviews.slice(0, 13);

const NavLinks = ({ closeMenu }) => {
  return (
    <Nav className="d-flex gap-4">
      {links.map((link) => (
        <NavLink
          key={link.id}
          to={link.btnUrl}
          className="nav-item text-white text-uppercase"
          onClick={closeMenu}
        >
          {link.title}
        </NavLink>
      ))}
    </Nav>
  );
};

export default NavLinks;
